import { ProductPricingTypeEnum } from 'generated/graphql';

export const isEcomPriceType = (
    pricingType: ProductPricingTypeEnum
): pricingType is ProductPricingTypeEnum.EcommercePricing => {
    return pricingType === ProductPricingTypeEnum.EcommercePricing;
};
